import { http } from "./http";
import type { ForYouResponse, TracksResponse } from "../types/spotify";

// Song search and feeds (the server talks to Spotify; the app never does).
export const spotifyApi = {
  /** Text search. Pass an AbortSignal to drop a stale request when the fan keeps typing. */
  search: (q: string, signal?: AbortSignal) =>
    http.get<TracksResponse>(`/spotify/search?q=${encodeURIComponent(q)}`, signal ? { signal } : undefined),
  byIds: (ids: string[]) => http.get<TracksResponse>("/spotify/by-ids", { params: { ids: ids.join(",") } }),
  /** The trending feed; `rand` shuffles it for the "for you" fallback, `dj`
      asks for that DJ's country chart (the reply's `country` says which). */
  trending: (limit: number, opts: { rand?: boolean; dj?: string } = {}) =>
    http.get<TracksResponse>(
      `/spotify/trending?${opts.rand ? "rand=1&" : ""}${opts.dj ? `dj=${encodeURIComponent(opts.dj)}&` : ""}limit=${limit}`
    ),
  /** "For you" shelves on a DJ's request page; `orders` = this device's past
      requests. fill=1: a thin "Popular at" shelf may be topped up with
      trending songs — this app reads popularLabel and says "Popular now". */
  forYou: (djSlug: string, orders: string[]) =>
    http.get<ForYouResponse>("/spotify/for-you", { params: { dj: djSlug, orders: orders.join(","), fill: 1 } }),
  recommend: (seedTrackIds: string[], limit: number) =>
    http.get<TracksResponse>(`/spotify/recommend?seed_tracks=${seedTrackIds.join(",")}&limit=${limit}`),
};
